import * as React from 'react';
import { Image, UIText1 } from '@cian/ui-kit';

import { ISpecialist } from '../../types/specialist';
import { Link } from '../link/link';

import * as styles from './styles.css';

interface ISpecialistRedesignProps {
  specialist: ISpecialist;
  isRoundPhoto?: boolean;

  onClick(): void;
  getSummary?(spec: ISpecialist): string;
}

export const SpecialistRedesign: React.FC<ISpecialistRedesignProps> = ({
  specialist,
  isRoundPhoto,
  getSummary,
  onClick,
}) => (
  <Link href={specialist.url} className={styles['container']} onClick={onClick} data-testid="SpecialistRedesign">
    <Image
      src={specialist.imageUrl}
      loading="lazy"
      objectFit="cover"
      display="block"
      preloader={false}
      borderRadius={isRoundPhoto ? '50%' : '4px'}
      width={60}
      height={60}
    />
    <div className={styles['specialists-info']}>
      <span className={styles['specialists-name']}>{specialist.title}</span>
      <UIText1 as="span" color="text-secondary-default">
        {getSummary ? getSummary(specialist) : specialist.offersCount}
      </UIText1>
    </div>
  </Link>
);
